const {cache0} = require("../../common/utils/cache0");
const {isTrue} = require("./is-true");

const isDevCuong = cache0(() => {
    try {
        return isTrue(localStorage.getItem("DEV_CUONG"));
    } catch (e) {
        return false;
    }
});
exports.isDevCuong = isDevCuong;
